<template>
  <div class="about-aecom-page">
    <div class="content-section">
      <h2>{{ t({ fr: "À propos d'AECOM et de notre rôle dans ce projet", en: 'About AECOM and our role in this project' }) }}</h2>

      <div class="aecom-intro">
        <h3>{{ t({ fr: 'Qui est AECOM ?', en: 'Who is AECOM?' }) }}</h3>
        <p>{{ t({
          fr: "AECOM est une entreprise de conseil en infrastructure de confiance à l'échelle mondiale, offrant des services professionnels en ingénierie, environnement, planification, géomatique et gestion de données pour les gouvernements et les organisations partout dans le monde.",
          en: "AECOM is a world-leading trusted infrastructure consulting firm, delivering professional services in engineering, environment, planning, geomatics and data management for governments and organizations worldwide."
        }) }}</p>
        <p>{{ t({
          fr: "Au Canada, AECOM compte plus de 4 000 professionnels répartis dans plus de 50 bureaux à travers le pays.",
          en: 'In Canada, AECOM has more than 4,000 professionals across more than 50 offices nationwide.'
        }) }}</p>
      </div>

      <div class="project-involvement">
        <h3>{{ t({
          fr: "Notre mandat : l'inventaire pancanadien des ouvrages de protection contre les inondations",
          en: 'Our mandate is to develop a Canada-wide inventory of flood protection systems.'
        }) }}</h3>
        <p>{{ t({
          fr: "AECOM a été mandatée par Ressources naturelles Canada (RNCan) pour élaborer un inventaire national consolidé des ouvrages de protection contre les inondations. Notre équipe multidisciplinaire travaille à :",
          en: 'AECOM has been mandated by Natural Resources Canada (NRCan) to develop a consolidated national inventory of flood-protection structures. Our multidisciplinary team is working to:'
        }) }}</p>
        <ul class="mandate-list">
          <li>{{ t({ fr: "Recueillir et consolider les données existantes provenant de multiples sources.", en: 'Collect and consolidate existing data from multiple sources.' }) }}</li>
          <li>{{ t({ fr: "Élaborer un modèle de données normalisé et bilingue.", en: 'Develop a standardized, bilingual data model.' }) }}</li>
          <li>{{ t({ fr: "Établir un cadre et un prototype pour l'inventaire national.", en: 'Establish a framework and prototype for the national inventory.' }) }}</li>
          <li>{{ t({ fr: "Identifier les lacunes de données et les moyens d'y remédier.", en: 'Identify data gaps and ways to fill them.' }) }}</li>
        </ul>
      </div>

      <div class="survey-context">
        <h3>{{ t({ fr: 'Pourquoi ce formulaire ?', en: 'What is this form?' }) }}</h3>
        <p>{{ t({
          fr: "Ce formulaire fait partie de la Tâche 4 du projet, qui vise à recueillir et à consolider les jeux de données existants sur les ouvrages de protection contre les inondations. Une plateforme sécurisée et conviviale permet aux intervenants de toutes les juridictions de soumettre leurs données et métadonnées de façon standardisée.",
          en: 'This form is how we will collect and consolidate existing datasets on flood protection systems. This platform lets stakeholders across all jurisdictions submit their data and metadata in a secure, standardized way.'
        }) }}</p>
      </div>

      <div class="commitment">
        <h3>{{ t({ fr: 'Notre engagement', en: 'Our commitment' }) }}</h3>
        <p>{{ t({
          fr: "AECOM s'engage à traiter vos données avec rigueur, transparence et sécurité, dans le respect des conditions de licence que vous précisez dans le formulaire.",
          en: 'AECOM is committed to handling your data with rigour, transparency and security, respecting the licensing conditions you specify in the form.'
        }) }}</p>
      </div>

      <StartSurveyButton :showBackButton="true" />
    </div>
  </div>
</template>

<script>
import StartSurveyButton from '../components/StartSurveyButton.vue'
import { t } from '../i18n/index.js'

export default {
  name: 'AboutAecomPage',
  components: { StartSurveyButton },
  methods: { t }
}
</script>

<style scoped>
.about-aecom-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 20px;
  line-height: 1.6;
}

.content-section {
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h2 {
  color: var(--aecom-midnight-teal);
  font-size: 1.7em;
  text-align: center;
  border-bottom: 3px solid var(--aecom-lime-green);
  padding-bottom: 15px;
  margin: 0 0 10px 0;
}

h3 {
  color: var(--aecom-earth-green);
  font-size: 1.35em;
  margin: 30px 0 15px 0;
  border-left: 4px solid var(--aecom-lime-green);
  padding-left: 15px;
}

p {
  margin-bottom: 15px;
  color: #333;
  text-align: justify;
}

.mandate-list {
  background-color: #f8f9fa;
  padding: 20px 20px 20px 25px;
  border-radius: 6px;
  border-left: 4px solid var(--aecom-earth-green);
  margin: 20px 0;
  list-style: none;
}

.mandate-list li {
  margin: 10px 0;
  padding-left: 25px;
  position: relative;
}

.mandate-list li::before {
  content: "✓";
  color: var(--aecom-earth-green);
  font-weight: bold;
  position: absolute;
  left: 0;
}

@media (max-width: 768px) {
  .content-section {
    padding: 24px;
  }
}
</style>
